import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const sensorsApi = createApi({
  reducerPath: 'sensorsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getSensors: builder.query({
      query: () => ({
        url: urls.sensors,
      }),
    }),
    getSensorsWithGraphableAttributes: builder.query({
      query: () => ({
        url: urls.sensorsWithGraphableAttributes,
      }),
    }),
    getSensorDetail: builder.query({
      query: (sensorId) => ({
        url: urls.sensorDetail(sensorId),
      }),
    }),
    editSensor: builder.mutation({
      query: ({ sensorId, values }) => ({
        url: urls.sensorDetail(sensorId),
        method: 'PATCH',
        data: values,
      }),
    }),
    deleteSensor: builder.mutation({
      query: (sensorId) => ({
        url: urls.sensorDetail(sensorId),
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetSensorDetailQuery,
  useGetSensorsWithGraphableAttributesQuery,
  useGetSensorsQuery,
  useEditSensorMutation,
  useDeleteSensorMutation,
} = sensorsApi;
